import React from "react";

const Bash_Pwd = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Pwd</h2>
      <p>Print the current working directory.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>pwd</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>pwd  # show /home/user/project</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Useful in scripts to determine the current path.</p>
    </div>
  );
};

export default Bash_Pwd;
